import { createInstance } from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next/initReactI18next";
import { defaultLng, getOptions, languages } from "./settings";
import { redirect } from "next/navigation";

const initI18next = async (lng: any, ns: any) => {
  const i18nInstance = createInstance();
  await i18nInstance
    .use(initReactI18next)
    .use(
      resourcesToBackend(
        (language: string, namespace: string) =>
          import(`./locales/${language}/${namespace}.json`)
      )
    )
    .init(getOptions(lng, ns));
  return i18nInstance;
};

export async function useTranslation(lng: any, ns: any, options: any = {}) {
  try {
    const i18nextInstance = await initI18next(lng, ns);
    //console.log(i18nextInstance);
    return {
      t: i18nextInstance.getFixedT(
        lng,
        Array.isArray(ns) ? ns[0] : ns,
        options.keyPrefix
      ),
      i18n: i18nextInstance,
    };
  } catch (error) {
    redirect("/th/404");
  }
}

export default function getClientText(lng: string, ns: string) {
  try {
    const key = require(`./locales/${lng}/${ns}.json`);
    return key;
  } catch (errror) {
    console.error(
      "Locale JSON file not found. Please check your file name and parameters in getTextClient function of Client component."
    );
  }
}
